import { QRFC } from "./QRFC";

export class QAuditSnapshotRFC extends QRFC {
  constructor() {
    super();
  }

  InitAuditSnapshotRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qauditsnapshot";
  }

  SetParams(orgName, user) {
    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", user);
  }

  DoTransactionComplete(response, callBackObj) {
    let parsed;
    try {
      parsed = JSON.parse(response);
    } catch (e) {
      callBackObj.AuditSnapshotResult(false, null);
      return;
    }
    callBackObj.AuditSnapshotResult(parsed.success === true, parsed);
  }
}
